// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressInfoDisplayStyles } from "@stoneage/Overrides/Components/AddressInfoDisplay";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";
import { fontConfig } from "@stoneage/XDL/constants";
import { mergeWithCss } from "@stoneage/XDL/Utilities";

const valueText: TypographyPresentationProps = {
    ...fontConfig.small,
    forwardAs: "p",
    transform: "capitalize",
    css: css`
        letter-spacing: 0;
    `,
};

addressInfoDisplayStyles.customerNameText =
    addressInfoDisplayStyles.attentionText =
    addressInfoDisplayStyles.companyNameText =
    addressInfoDisplayStyles.customerNumberText =
    addressInfoDisplayStyles.address1Text =
    addressInfoDisplayStyles.address2Text =
    addressInfoDisplayStyles.address3Text =
    addressInfoDisplayStyles.address4Text =
    addressInfoDisplayStyles.cityStatePostalCodeText =
    addressInfoDisplayStyles.countryText =
        {
            ...valueText,
        };

addressInfoDisplayStyles.phoneText = addressInfoDisplayStyles.emailText = {
    ...mergeWithCss(valueText, {
        css: css`
            margin-top: 8px;
        `,
    }),
};

addressInfoDisplayStyles.billingContactText = {
    variant: "h4",
};
